import { UntypedFormControl, ValidationErrors } from '@angular/forms';
import parsePhoneNumberFromString from 'libphonenumber-js';

export function speedDialPhoneNumberValidator(control: UntypedFormControl): ValidationErrors | null {
  const value = control.value?.trim();
  if (!value) {
    return null;
  }

  // Allow star codes like *67, *82, *1234, etc.
  const starCodePattern = /^\*\d+$/;
  if (starCodePattern.test(value)) {
    return null;
  }

  // Validate as a phone number
  const phoneNumber = parsePhoneNumberFromString(value, { defaultCountry: 'US', extract: true });

  if (phoneNumber?.isValid()) {
    return null;
  }

  return { invalidNumber: true };
}
